import {ApplicationCurrentStepResource} from '@/common/api/api-raw-types';
import {CreationStepName} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';

const stepResourceToNameMap: Record<ApplicationCurrentStepResource, CreationStepName> = {
    LINKEDIN_IMPORT: CreationStepName.COMPLETION_LINKEDIN,
    EDUCATION: CreationStepName.COMPLETION_EDUCATION,
    WORK_EXPERIENCE: CreationStepName.COMPLETION_EXPERIENCE,
    DESCRIPTION_PHOTO: CreationStepName.COMPLETION_DESCRIPTION,
    FREELANCER_EXPERIENCE: CreationStepName.COMPLETION_PRIVACY,
};

const stepNameToResourceMap: Record<CreationStepName, ApplicationCurrentStepResource> = {
    [CreationStepName.COMPLETION_LINKEDIN]: 'LINKEDIN_IMPORT',
    [CreationStepName.COMPLETION_EDUCATION]: 'EDUCATION',
    [CreationStepName.COMPLETION_EXPERIENCE]: 'WORK_EXPERIENCE',
    [CreationStepName.COMPLETION_DESCRIPTION]: 'DESCRIPTION_PHOTO',
    [CreationStepName.COMPLETION_PRIVACY]: 'FREELANCER_EXPERIENCE',
} as any;

export function toApplicationCurrentStepResource(stepName: CreationStepName): ApplicationCurrentStepResource | undefined {
    return stepNameToResourceMap[stepName];
}

export function toStepName(stepResource: ApplicationCurrentStepResource): CreationStepName | undefined {
    return stepResourceToNameMap[stepResource];
}
